import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const fileDeleteAtom = createMutationAtomFactory(
  'customerPortal.fileDelete',
  (params: { fileId: string }) => ({
    filesDeleteFile: {
      __args: {
        fileID: params.fileId,
      },
      success: true,
    },
  }),
  {
    select: (data) => data.filesDeleteFile.success,
  },
);
